import React, { useState } from "react";
import {
  Typography,
  Button,
  Box,
  Tab,
  Tabs,
} from "@mui/material";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import ProspectKYCForm from "../../customers/prospect-kyc/prospectKYCForm";
import CustomerAccount from "../../customers/profile/customerAccount";
// import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

const CustomerProfile = () => {
  const [activeTab, setActiveTab] = useState("docs");
  const { customerId } = useParams<{ customerId: string }>();
  const navigate = useNavigate();

  const handleChange = (_: any, newValue: string) => {
    setActiveTab(newValue);
  };
 
  return (
    <div className="flex min-h-screen bg-gray-50">
      <div className="flex-1 p-4 sm:p-7 overflow-y-auto">
        <div className="flex flex-col sm:flex-row sm:items-center mb-4 gap-2">
          <Button
            onClick={() => navigate(-1)}
            variant="contained"
            color="primary"
            startIcon={<ArrowBackIcon />}
            sx={{
              borderRadius: 2,
              fontWeight: 600,
              width: { xs: '100%', sm: 'auto' },
              mb: { xs: 1, sm: 0 }
            }}
          >
            Back
          </Button>

          <Typography variant="h5" className="font-bold text-gray-800 text-center sm:text-left">
            Customer Profile
          </Typography>
        </div>

        <Box className="mb-3 bg-white p-2 sm:p-4 rounded-xl shadow-sm border border-gray-100">
          <Tabs
            value={activeTab}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            TabIndicatorProps={{ style: { display: "none" } }}
            sx={{
              "& .MuiTab-root": {
                minHeight: { xs: 70, sm: 90 },
                minWidth: { xs: 80, sm: 120 },
                borderRadius: "12px",
                marginX: { xs: 0.5, sm: 1 },
                textTransform: "none",
                fontWeight: 500,
                color: "#6b7280",
                transition: "all 0.3s ease",
                display: "flex",
                flexDirection: "column",
                gap: { xs: "4px", sm: "8px" },
                padding: { xs: "8px 12px", sm: "12px 16px" },
              },
              "& .MuiTab-root:hover": {
                backgroundColor: "#f9fafb",
              },
              "& .Mui-selected": {
                background: "linear-gradient(90deg, #3b82f6 0%, #6366f1 100%)",
                color: "white !important",
                boxShadow: "0 4px 12px rgba(59,130,246,0.3)",
                "& .MuiSvgIcon-root.new-loan-icon": {
                  color: "white !important",
                },
              },
              "& .MuiTabs-scrollButtons": {
                color: "#3b82f6",
              },
            }}
          >
            <Tab
              value="user"
              label={
                <div className="flex flex-col items-center">
                  <img
                    src="https://img.icons8.com/color/96/user-male-circle--v1.png"
                    alt="User Info"
                    className="w-8 h-8 sm:w-12 sm:h-12 mb-1"
                  />
                  <span className="text-xs sm:text-sm font-medium">User Info</span>
                </div>
              }
            />
            <Tab
              value="docs"
              label={
                <div className="flex flex-col items-center">
                  <img
                    src="https://img.icons8.com/color/96/documents.png"
                    alt="Prospect KYC"
                    className="w-8 h-8 sm:w-12 sm:h-12 mb-1"
                  />
                  <span className="text-xs sm:text-sm font-medium">Prospect KYC</span>
                </div>
              }
            />
            {/* <Tab
              value="newLoan"
              label={
                <div className="flex flex-col items-center">
                  <AttachMoneyIcon
                    className={`w-8 h-8 sm:w-12 sm:h-12 mb-1 new-loan-icon ${
                      activeTab === "newLoan" ? "text-white" : "text-blue-500"
                    }`}
                    fontSize="medium"
                  />
                  <span className="text-xs sm:text-sm font-medium">New Deal</span>
                </div>
              }
            /> */}
          </Tabs>
        </Box>

        {/* User Tab Content */}
        {activeTab === "user" && (
          <CustomerAccount customerId={customerId || ""}></CustomerAccount>
        )}

        {/* Documents Tab Content */}
        {activeTab === "docs" && (
          <ProspectKYCForm customer_id={customerId || ""}></ProspectKYCForm>
        )}

        {/* {activeTab === "newLoan" && (
        )} */}
      </div>
    </div>
  );
};

export default CustomerProfile;
